// extracted by mini-css-extract-plugin
export var about = "products-module--about--uCEfB";
export var aboutCenter = "products-module--about-center--yuYrt";
export var aboutImg = "products-module--about-img--ID0Nb";
export var aboutInfo = "products-module--about-info--LFz3A";
export var imgContainer = "products-module--img-container--HKe+D";